/**
 * Returns true when the backend marked the principal as already active in some account.
 * In that case the backend also updates the Firebase user's `emailVerified` flag during
 * token exchange — the auth engine reads this to decide whether to call
 * `firebaseUser.reload()` and re-check verification before falling back to
 * `email-unverified`.
 */
export function hadActivityForPrincipal(subject) {
    const user = Object.values(subject?.principal?.user || {})[0];
    return Boolean(user?.had_activity);
}
